import { lazy } from 'react';

import type { ModuleWeb } from '../registry.js';

// Écrans de la boutique chargés à la demande (spec 008, espace bénévole simplifié ; parcours
// catalogue → produit → panier du chantier AE).
const pages = () => import('./ShopPages.js');
const CataloguePage = lazy(() => pages().then((m) => ({ default: m.CataloguePage })));
const ProduitPage = lazy(() => pages().then((m) => ({ default: m.ProduitPage })));
const PanierPage = lazy(() => pages().then((m) => ({ default: m.PanierPage })));
const MesCommandesPage = lazy(() => pages().then((m) => ({ default: m.MesCommandesPage })));
const CommandePage = lazy(() => pages().then((m) => ({ default: m.CommandePage })));
const gestion = () => import('./GestionPages.js');
const CommandesGestionPage = lazy(() =>
  gestion().then((m) => ({ default: m.CommandesGestionPage })),
);
const RetraitPage = lazy(() => gestion().then((m) => ({ default: m.RetraitPage })));
const ProduitsGestionPage = lazy(() => gestion().then((m) => ({ default: m.ProduitsGestionPage })));
const ReglagesBoutiquePage = lazy(() =>
  gestion().then((m) => ({ default: m.ReglagesBoutiquePage })),
);
const VentesPage = lazy(() => gestion().then((m) => ({ default: m.VentesPage })));
const EngagementBoutiqueTab = lazy(() =>
  import('./PersonTab.js').then((m) => ({ default: m.EngagementBoutiqueTab })),
);

export const boutiqueWeb: ModuleWeb = {
  module: 'boutique',
  personTabs: [
    {
      key: 'engagement-boutique',
      label: 'Engagement et boutique',
      render: (personId) => <EngagementBoutiqueTab personId={personId} />,
    },
  ],
  routes: [
    { path: '/boutique', element: <CataloguePage /> },
    { path: '/boutique/produits/:id', element: <ProduitPage /> },
    { path: '/boutique/panier', element: <PanierPage /> },
    { path: '/boutique/mes-commandes', element: <MesCommandesPage /> },
    { path: '/boutique/mes-commandes/:id', element: <CommandePage /> },
    { path: '/boutique/gestion/commandes', element: <CommandesGestionPage /> },
    { path: '/boutique/retrait/:token', element: <RetraitPage /> },
    { path: '/boutique/gestion/produits', element: <ProduitsGestionPage /> },
    { path: '/boutique/gestion/reglages', element: <ReglagesBoutiquePage /> },
    { path: '/boutique/gestion/ventes', element: <VentesPage /> },
  ],
};
